import React, {useContext, useEffect} from 'react'
import {Form, DatePicker} from "antd";
import {OfferContext} from "../../../context/OfferContext";
import moment from "moment";

const dateFormat = "DD/MM/YYYY"

const OfferCreateShippingDate = ({rowIndex, record}) => {

    const [form] = Form.useForm()
    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        form.setFieldsValue({
            [`${rowIndex}-shipping`]: record.shippingDate
                        ? moment(record.shippingDate, 'YYYY/MM/DD')
                        : ''
        })
    }, [rowIndex, record])

    const handleChange = (value) => {
        let mockContext = [...materials]
        mockContext[rowIndex].shippingDate = value._d
        setMaterials(mockContext)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
            >
                <Form.Item
                    name={`${rowIndex}-shipping`}
                >
                    <DatePicker onChange={handleChange} format={dateFormat} placeholder={'Tarih Seçiniz'} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferCreateShippingDate